var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"accueil"},[_c('div',{staticClass:"contains w-25"},[_c('b-button',{staticClass:"backresultats button_accueil_style mb-4",attrs:{"to":"/Resultats","block":""}},[_vm._v("Vos résultats")]),_vm._v(" "),(_vm.$root.user.roles.ENREG === 1)?_c('b-button',{staticClass:"backanalyse button_accueil_style mb-4",attrs:{"to":"/Demande/Nouvelle","block":""}},[_vm._v("Demandes d'analyses")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02473aa5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccueilComponent.vue
// module id = 543
// module chunks = 1